<template>
    <div class="page-store-product">
        <article class="product-details" v-if="product">
            <header class="mobile-product-title">
                <h2 class="title">{{ product.title }}</h2>
                <h3 class="price">{{ currentPrice | currency }}</h3>
            </header>

            <section class="product-images">
                <div class="expand-wrapper">
                    <slick
                        class="product-carousel"
                        ref="slick"
                        v-bind:options="slickOptions"
                        @afterChange="handleAfterImageChange"
                    >
                        <div
                            class="slide"
                            v-for="(image, index) in product.images"
                            v-bind:key="index"
                        >
                            <div class="image" :style="{ backgroundImage: `url(${image.src})`}"></div>
                            <img :src="image.src" />
                        </div>
                    </slick>
                </div>
            </section>

            <section class="product-content">
                <h2 class="product-title">{{ product.title }}</h2>

                <aside class="tablet-pagination">
                    <div class="carousel-pages-wraper -tablet">
                        <button class="prev-image" @click="onPreviousImageClick()">
                            <i class="storror-icon">
                                <CaretLeftIcon />
                            </i>
                        </button>
                        <div class="slick-pages-tablet">
                            <Pagination
                                :active="activeImagePage"
                                :pages="product.images.length"
                                v-on:page-change="onChangePage($event)"
                            />
                        </div>
                        <button class="next-image" @click="onNextImageClick()">
                            <i class="storror-icon">
                                <CaretRightIcon />
                            </i>
                        </button>
                    </div>
                </aside>

                <div class="main-content">
                    <div class="carousel-pages-wraper -mobile">
                        <button class="prev-image" @click="onPreviousImageClick()">
                            <i class="storror-icon">
                                <CaretLeftIcon />
                            </i>
                        </button>
                        <div class="slick-pages-mobile">
                            <Pagination
                                :active="activeImagePage"
                                :pages="product.images.length"
                                v-on:page-change="onChangePage($event)"
                            />
                        </div>
                        <button class="next-image" @click="onNextImageClick()">
                            <i class="storror-icon">
                                <CaretRightIcon />
                            </i>
                        </button>
                    </div>

                    <div class="variants">
                        <div class="variant-options">
                            <div class="variant-control" v-if="product.options[0].values.length > 1">
                                <label for="variant">Size</label>
                                <select id="variant" name="variant" v-model="selectedVariant" @change="onVariantChange()">
                                    <option disabled="disabled" class="default" value="">
                                        Select an Option 
                                    </option>
                                    <option v-for="(option, index) in product.options[0].values" v-bind:value="option.value" v-bind:key="index" v-bind:disabled="!product.variants[index].available">
                                        {{ option.value == 'Default Title' ? 'One size' : option.value }} {{ product.variants[index].available == false ? '[Out of Stock]' : '' }}
                                    </option>
                                </select>
                                <span class="line"></span>
                            </div>
                            <div class="variant-control" v-if="product.options[0].values.length == 1">
                                <input type="hidden" name="variant" v-bind:value="product.options[0].values[0]">
                                <label for="variant">One Size</label>
                                <span class="line"></span>
                            </div>
                        </div>
                        <button
                            class="btn btn-primary cart-btn"
                            :disabled="!variant.available"
                            @click="onAddtoCart()"
                        >
                            {{ variant.available ? ' Add to Cart' : 'Sold Out '}}
                        </button>
                    </div>

                    <div class="add-cart-container">
                        <button
                            class="btn btn-primary cart-btn"
                            :disabled="!variant.available"
                            @click="onAddtoCart()"
                        >
                            {{ variant.available ? ' Add to Cart' : 'Sold Out '}}
                        </button>
                    </div>

                    <div class="description" v-html="product.descriptionHtml"></div>

                    <div class="more-info">
                        <div class="price">
                            <div class="current-price">{{ currentPrice | currency  }}</div>
                            <div class="compare-price" v-if="variant.compareAtPrice && variant.compareAtPrice > 0">{{ variant.compareAtPrice | currency }}</div>
                        </div>
                    </div>
                </div>

                <div class="bottom-content">
                    <div class="product-actions">
                        <div class="carousel-pages-wraper -desktop">
                            <button class="prev-image" @click="onPreviousImageClick()">
                                <i class="storror-icon">
                                    <CaretLeftIcon />
                                </i>
                            </button>
                            <div class="slick-pages-desktop">
                                <Pagination
                                    :active="activeImagePage"
                                    :pages="product.images.length"
                                    v-on:page-change="onChangePage($event)"
                                />
                            </div>
                            <button class="next-image" @click="onNextImageClick()">
                                <i class="storror-icon">
                                    <CaretRightIcon />
                                </i>
                            </button>
                        </div>
                    </div>
                </div>


                <div class="back-to-store">
                    <a class="btn btn-primary btn-outline" href="/store">
                        <i class="storror-icon">
                            <CaretLeftIcon />
                        </i> Back to Store
                    </a>
                </div>
            </section>
        </article>

    </div>
</template>

<script>
import ShopifyClient from '@/shopify';
import Slick from 'vue-slick';
import Pagination from '@/components/Pagination';

import CaretLeftIcon from '@/assets/icons/caret-left.svg';
import CaretRightIcon from '@/assets/icons/caret-right.svg';

export default {
    name: 'product',
    components: {
        Pagination,
        Slick,
        CaretLeftIcon,
        CaretRightIcon,
    },
    data() {
        return {
            cartId: null,
            variant: {
                loaded: false
            },
            variantIndex: null,
            product: null,
            selected: null,
            selectedVariant: null,
            activeImagePage: 0,
            slickOptions: {
                dots: false,
                fade: true,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                mobileFirst: true,
                responsive: [
                    { breakpoint: 767 },
                    { breakpoint: 991 },
                ],
            },
        };
    },
    created() {
        // console.log('%c[ PRODUCT ]', 'color: red', this.$route.params.id);
        ShopifyClient.product.fetchByHandle(this.$route.params.id).then((product) => {

            this.product = product;
            this.variantIndex = 0;

            this.selected = null;
            this.selectedVariant = null;

        console.log('%c[ PRODUCT ]', 'color: red', this.product.variants);


            if(this.product == null)
            {
                if(typeof Sentry !== 'undefined'){
                    Sentry.withScope(scope => {
                        scope.setExtra("product_route", this.$route.params)
                        Sentry.captureException('Product Access Denied')
                    });
                }
                this.$router.push('/');
                return;
            }
                for (var i = 0; i < this.product.variants.length; i++) {
                    if(this.product.variants[i].available === true && this.selected === null && this.selectedVariant === null)
                    {
                        this.variant = this.product.variants[i];
                        this.selected = this.product.options[0].values[i].value;
                        this.selectedVariant = this.product.options[0].values[i].value;
                    }
                    else
                    {
                        // console.log('Out of Stock', product.variants[i], product.options[0].values[i]);
                    }
                }

                if(this.selectedVariant == null)
                {
                    this.selected = product.options[0].values[0].value;
                    this.selectedVariant = product.options[0].values[0].value;
                }
        }, (error) => {
            console.log('Errors', error);
        });

        // Set the checkout ID
        this.cartId = localStorage.getItem('checkout_id');

        // console.log('%c[ Product ] - Cart ID', 'color: green', this.cartId);

        if (!this.cartId) {
            this.createCart();
        } else {
            ShopifyClient.checkout.fetch(this.cartId).then((checkout) => {
                // console.log('%c[ Product ] - Cart-check', 'color: orange', checkout.lineItems);
            })
            .catch((err) => {
                this.createCart();

                // console.log('%c[ Product ] - checkout error', 'color: orange', err);
                // console.log('%c[ Product ] - New cart ID', 'color: orange', this.cartId);
            });
        }
    },
    methods: {
        createCart() {
            ShopifyClient.checkout.create().then((checkout) => {
                // console.log('%c -> Variant ID', 'color: purple', checkout);

                localStorage.setItem('checkout_id', checkout.id);
                this.cartId = checkout.id;
            });
        },
        onAddtoCart() {
            // console.log('%c[ Product ] - Add to Cart', 'color: green');
            // console.log('%c -> Checkout ID', 'color: green', this.cartId);
            // console.log('%c -> Variant ID', 'color: green', this.variant.id);

            const lineItemsToAdd = [
                { variantId: this.variant.id, quantity: 1, },
            ];

            ShopifyClient.checkout.addLineItems(this.cartId, lineItemsToAdd).then((checkout) => {
                // console.log('%c[ Product ] - Added to cart', 'color: blue', checkout);
                if (window.updateCartData) {
                    window.updateCartData(checkout);
                }
            });
        },
        onVariantChange() {
            this.variant = this.product.variants.find((variant) => {
                return variant.title === this.selectedVariant;
            });
        },
        onChangePage(pageIndex) {
            this.$refs.slick.goTo(pageIndex);
            this.activeImagePage = pageIndex;
        },
        onPreviousImageClick() {
            this.$refs.slick.prev();
        },
        onNextImageClick() {
            this.$refs.slick.next();
        },
        handleAfterImageChange(event, slick, currentSlide) {
            this.activeImagePage = currentSlide;
        },
    },
    computed: {
        currentPrice() {
            if(this.variant.loaded === false)
            {
                return this.product.variants[0].price
                
            }
            else
            {
                return this.variant.price
            }
        },
    }
};
</script>

<style lang="scss" scoped>
.page-store-product {
    min-height: 200px;
}

select {
    option {
        background: #efefef;
        &:disabled:not(.default) {
            color: #888888;
        }
        &:checked {
            color: #888888;

        }
    }
}

</style>
